import { CustomCard } from "../../../components/custom-card/custom-card";
import {
  FaBox,
  FaCartFlatbedSuitcase,
  FaFileInvoice,
  FaSitemap,
  FaUserGroup,
} from "react-icons/fa6";
import { RiNumbersFill } from "react-icons/ri";
import { GrTransaction } from "react-icons/gr";
import BarChart from "../../../components/charts/bar-chart";
import { useEffect, useState } from "react";
import { dataDecrypt, encrypt } from "../../../app/utility/encryption-helper";
import { ApisService } from "../../../app/core/apis.service";
import toast from "react-hot-toast";

export const DashboardInfoPage = () => {
  const [totalBus, setTotalBus] = useState<number>(0);
  const [totalUsers, setTotalUsers] = useState<number>(0);
  const [retailInvoice, setRetailInvoice] = useState<number>(0);
  const [transactionInvoice, setTransactionInvoice] = useState<number>(0);
  const [fromDate, setFromDate] = useState<any>(null);
  const [toDate, setToDate] = useState<any>(null);
  useEffect(() => {
    getRetailInvoices("");
    getTotalBus("");
    getTotalTransactionInvoices("");
    getTotalUsers("");
  }, []);
  const getRetailInvoices = async (data: any) => {
    try {
      let encrytedData = encrypt(JSON.stringify(data));
      const res = await ApisService.retailerApi("getTotalInvoices", encrytedData);
      const retailData = JSON.parse(dataDecrypt(res?.data?.data));
      setRetailInvoice(retailData.total);
    }
    catch (error) {
    }
  }

  const getTotalBus = async (data: any) => {
    try {
      let encrytedData = encrypt(JSON.stringify(data));
      const busData = await ApisService.getOrganizationData("getTotalBus", encrytedData);
      const totalbu = JSON.parse(dataDecrypt(busData?.data?.data));
      setTotalBus(totalbu.total);
    }
    catch (error) {
    }
  }

  const getTotalTransactionInvoices = async (data: any) => {
    try {
      let encrytedData = encrypt(JSON.stringify(data));
      const totalTransactions = await ApisService.transactionApi("totalTransactions", encrytedData);
      const trnsInvoice = JSON.parse(dataDecrypt(totalTransactions?.data?.data));
      setTransactionInvoice(trnsInvoice.total);
    }
    catch (error) {
    }
  }

  const getTotalUsers = async (data: any) => {
    try {
      let encrytedData = encrypt(JSON.stringify(data));
      const totalUsers = await ApisService.usersApi("getAllUsers", encrytedData);
      const userCount = JSON.parse(dataDecrypt(totalUsers?.data?.data));
      setTotalUsers(userCount.total);
    }
    catch (error) {
    }
  }

  const invoicesData: any[] = [
    {
      id: "1",
      name: "Total Number of BU'S",
      count: totalBus,
      icon: <FaSitemap size={45} />,
      navigate: `/dashboard/organizations`,
      backgroundColor: "#387478",
    },
    {
      id: "2",
      name: "Total Transaction Invoices",
      count: transactionInvoice,
      icon: <FaFileInvoice size={45} />,
      backgroundColor: "#FF8B8B",
    },
    {
      id: "3",
      name: "Total Retail Invoices",
      count: retailInvoice,
      icon: <FaFileInvoice size={45} />,
      backgroundColor: "#AA60C8",
    },
    // {
    //   id: "4",
    //   name: "Total Number of Products",
    //   count: 150,
    //   icon: <FaBox size={45} />,
    //   backgroundColor: "#9772FB",
    // },
    // {
    //   id: "5",
    //   name: "Total Number of ONDC Orders",
    //   count: 98,
    //   icon: <FaCartFlatbedSuitcase size={45} />,
    //   backgroundColor: "#FF7272 ",
    // },
    {
      id: "6",
      name: "Total Number of Users",
      count: totalUsers,
      icon: <FaUserGroup size={45} />,
      backgroundColor: "#F9975D",
      navigate: `/dashboard/registration`,
    },
    // {
    //   id: "7",
    //   name: "Avg Order Values",
    //   count: "1000",
    //   icon: <RiNumbersFill size={45} />,
    //   backgroundColor: "#F075AA",
    // },
    // {
    //   id: "8",
    //   name: "Total Monthly Transactions",
    //   count: "10 Lakhs",
    //   icon: <GrTransaction size={45} />,
    //   backgroundColor: "#A28B55",
    // },
  ];

  // const barChartDataData = {
  //   labels: [
  //     "SwiftSales Hub",
  //     "PeakSell Solutions",
  //     "Veloce Commerce",
  //     "NextGen Marketplace",
  //     "PrimeTrade Ventures",
  //   ],
  //   label: "Monthly 1 sep - 30 sep",
  //   barChart_data: ["100", "250", "380", "280", "500"],
  //   backgroundColor: "#074173",
  //   borderColor: "white",
  //   borderWidth: 1,
  //   xAxis: "Company",
  //   yAxis: "No of Orders",
  // };

  // const CategoriesChartDataData = {
  //   labels: [
  //     "Noise Electronics",
  //     "Pick & Buy store",
  //     "Sree Ram cotton",
  //     "Sonia electronics",
  //     "A2Square Enterprises",
  //   ],
  //   label: "Monthly 1 sep - 30 sep",
  //   barChart_data: ["100", "250", "380", "280", "500"],
  //   backgroundColor: "#804674",
  //   borderColor: "white",
  //   borderWidth: 1,
  //   xAxis: "Categories",
  //   yAxis: "No of Orders",
  // };

  // const ChartData = {
  //   labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
  //   label: "Orders",
  //   barChart_data: ["10", "25", "18", "25", "58", "40", "90"],
  //   backgroundColor: "#04364A",
  //   borderColor: "white",
  //   borderWidth: 1,
  //   xAxis: "Days",
  //   yAxis: "No of Orders",
  // };

  const handleFromDate = (date: any) => {
    setFromDate(date);
  }

  const handleToDate = (date: any) => {
    setToDate(date);
  }

  const onSubmitData = () => {
    let payload = { filters: { DateFrom: fromDate, DateTo: toDate } };
    getRetailInvoices(payload);
    getTotalBus(payload);
    getTotalTransactionInvoices(payload);
    getTotalUsers(payload);
  }

  const onCancelData = () => {
    setFromDate("");
    setToDate("");
    let payload = "";
    getRetailInvoices(payload);
    getTotalBus(payload);
    getTotalTransactionInvoices(payload);
    getTotalUsers(payload);
  }

  return (
    <div className="container-fluid content-bg-color">
      <h4>Dashboard</h4>
      <hr className="mt-0" />
      <div className="row  pb-2">
        <div className="row">
          <div className="col-md-5 mb-3">
            <input type="date" className="form-control primary-border" id="startDate" name="startDate" value={fromDate} onChange={(e) => { handleFromDate(e.target.value) }} />
          </div>
          <div className="col-md-5 mb-3">
            <input type="date" className="form-control primary-border" id="endDate" name="endDate" value={toDate} min={fromDate} onChange={(e) => { handleToDate(e.target.value) }} />
          </div>
          <div className="col-md-2">
            <button className="me-1 px-3 rounded py-1 primary-bg primary-border text-white" onClick={() => onSubmitData()}>Submit</button>
            <button className="px-3 rounded py-1 primary-border primary-color bg-white" onClick={() => onCancelData()}>Cancel</button>
          </div>
        </div>

        <CustomCard
          contentData={invoicesData}
          customClass={true}
          blogsContent={true}
        />
      </div>

      {/* <div className="row">
        <div className="col-md-6">
          <h4 className="mb-3">Orders By Company</h4>
          <BarChart data={barChartDataData} />
        </div>
        <div className="col-md-6">
          <h4 className="mb-3">Orders By Category</h4>
          <BarChart data={CategoriesChartDataData} />
        </div>
      </div>
      <div className="col-md-6">
        <h4 className="mt-3">Daily Orders</h4>
        <BarChart data={ChartData} />
      </div> */}
    </div>
  );
};
